export { default } from './HowItWorksCard';
